import { Injectable } from "@angular/core";
import { Role } from '@enums/role.enum';
import { hideIntercom, showIntercom } from '@utilities/function-utils';
import { UserModel } from '@models/index';
import { environment } from '@environments/environment';

/**
 * AppService contains
 * all services related to the app
 * flow in general
 */
@Injectable({
  providedIn: 'root'
})
export class AppService {

  /**
   * AppService Constructor
   */
  constructor() { }

  /**
   * Validates if the intercom widget should
   * be shown or not depending on the user role
   * and the project environment.
   */
  validateIntercomUser = (user: UserModel) => (user.email != "" &&
    (user.role.name === Role.Reseller ||
    ((user.role.name === Role.BusinessAdmin || user.role.name === Role.UserBusiness) &&
      ((environment.intercomDomainValidations.find(element => element.test(window.location.href)) && environment.production) ||
      user.reseller.name === "Get More Reviews"))));

      /**
       * Decides if intercom widget should be shown or not
       * and with which brand should be shown.
       * @param user The current logged user
       * @param parentEntityName The business name if it exists.
       */
  changeIntercomStatus(user: UserModel, parentEntityName?: string) {
    this.validateIntercomUser(user) ?
      user.role.name === Role.Reseller ? showIntercom(user, user.reseller.name) : showIntercom(user, parentEntityName) :
      hideIntercom();
  }

}